import { distinctUntilChanged, switchMap, map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import { PerformanceFactsPortfolioGQL, PerformanceFactsParkGQL, PerformanceFactsTurbineGQL } from '../../graphql';
import { PerformanceFacts } from 'app/models/monitor/performance-facts.model';
import {NavigationDetails} from '../../navigation/navigation.service';

@Injectable()
export class PerformanceFactsService {

    constructor(
        private performanceFactsPortfolioGQL: PerformanceFactsPortfolioGQL,
        private performanaceFactsParkGQL: PerformanceFactsParkGQL,
        private performanaceFactsTurbineGQL: PerformanceFactsTurbineGQL,
    ) { }


    public getPerformanceFactsPortfolioData(navigationDetails: NavigationDetails): Observable<PerformanceFacts> {
      return this.performanceFactsPortfolioGQL.subscribe({
        variables: {
            portfolioId: navigationDetails.selectedPortfolioId, parksIds: navigationDetails.selectedParksIds
        }
      }).pipe(
        map(result => PerformanceFacts.mapFromPortfolio(result.data.portfolios[0])
      ));
    }

    public getPerformanceFactsParkData(parkNameObservable: Observable<string>,
                                       selectedTurbineIds: string[]): Observable<PerformanceFacts> {
        return combineLatest([
            parkNameObservable
        ]).pipe(
            distinctUntilChanged(),
            switchMap(([name]) => {
                    return this.performanaceFactsParkGQL.subscribe({
                        variables: {
                            name,
                            turbineIds: selectedTurbineIds
                        }
                    }).pipe(
                        map(result => PerformanceFacts.mapFromPark(result.data.parks[0]))
                    )
                }
            )
        );
    }

    public getPerformanceFactsTurbineData(turbineSerialObservable: Observable<number>): Observable<PerformanceFacts> {
        return turbineSerialObservable.pipe(
            distinctUntilChanged(),
            switchMap((serialNav: number) =>
                this.performanaceFactsTurbineGQL.subscribe({
                    variables: {
                        serialNav
                    }
                }).pipe(
                    map(result => PerformanceFacts.mapFromTurbine(result.data.turbines[0])
                    )
                )
            )
        );
    }

}
